<template>
  <div class="">
    <!-- <div class="head-title">新增客户数据统计</div> -->
    <el-page-header class="page-header" @back="goBack" content="新增客户数据统计">
    </el-page-header>
    <div class="help">
      <p>统计员工新增客户数量，根据天、周、季度、年、成员来进行筛选统计。</p>
    </div>
    <!-- <div class="nav">
        渠道活码功能是非常实用的功能，可以实现同一个二维码，扫码后添加不同的客服（销售）人员。如果同时在企业微信官方后台配置了欢迎语，<a
          href=""
          >查看教程</a>
      </div> -->
    <!-- <div class="botm-nav">
          <span>数据统计</span>
        </div> -->
    <div class="mMain">
      <nav class="navbar">
        <div class="nav-r">
          <div @click="openDrawer()">
            <el-input placeholder="请选择成员" prefix-icon="el-icon-search" style="width: 20rem; margin: 0 2rem 0 2rem"
              v-model="originUser">
            </el-input>
          </div>
          <div class="time" style="margin-right: 2.4rem">
            <!-- <span>添加时间:</span> -->
            <el-date-picker v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期" :picker-options="pickerOptions" @change="userTable">
            </el-date-picker>
          </div>
          <el-select clearable v-model="value" placeholder="请选择" style="width: 24rem; min-width: auto; margin-right: 2rem"
            @change="getActiveCode">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" @click="getActiveCode">查询</el-button>
        </div>
      </nav>
      <div id="myChart" :style="{
        width: '100%',
        height: '50rem',
      }"></div>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
let ming = require("echarts/lib/echarts");
// 引入地图
require("echarts/map/js/china.js");
// 引入饼状图组件
require("echarts/lib/chart/pie");
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople'
export default {
  components: {
    rightPeople,
  },
  data() {
    return {
      checkbox: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      tooken: [],
      tableData: [],
      username: "",
      page: "",
      value1: "",
      start_time: "",
      end_time: "",
      options: [
        {
          value: "year",
          label: "本年",
        },
        {
          value: "lastYear",
          label: "去年",
        },
        {
          value: "quarter",
          label: "本季度",
        },
        {
          value: "lastQuarter",
          label: "上季度",
        },
        {
          value: "month",
          label: "本月",
        },
        {
          value: "lastMonth",
          label: "上月",
        },
        {
          value: "week",
          label: "本周",
        },
        {
          value: "lastWeek",
          label: "上周",
        },
        {
          value: "tody",
          label: "今天",
        },
        {
          value: "yesterday",
          label: "昨天",
        },
      ],
      value: "month",
      module: "", //address组件执行哪个接口字段
      originUser: "", //选择成员搜索字段
      originUserId: "", //选择成员搜索的userid
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.drawLine();
  },
  watch: {
    originUser() {
      if (this.originUser == "") {
        this.originUserId = ""
      }
      this.userTable()
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    userTable() {
      let a = "";
      let b = "";
      if (Array.isArray(this.value1)) {
        a = new Date(this.value1[0]).getTime();
        b = new Date(this.value1[1]).getTime();
        b = Number.parseInt((b * 1) / 1000);
        a = Number.parseInt((a * 1) / 1000);
      }
      this.start_time = a;
      this.end_time = b;
      this.drawLine();
    },
    drawLine() {
      this.axios
        .post(
          "/crm/ActiveCode/getNumTotal",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            type: this.value,
            userid: this.originUserId,
            start_time: this.start_time,
            end_time: this.end_time,
          }),
          {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          }
        )
        .then((res) => {
          const arr = [];
          res.data.data.forEach((item) => {
            arr.push(item.date);
          });
          const aee = [];
          res.data.data.forEach((item) => {
            aee.push(item.num);
          });
          let myChart = this.$echarts.init(document.getElementById("myChart"));
          let bgColor = "#fff";
          let color = [
            "#0090FF",
            "#36CE9E",
            "#FFC005",
            "#FF515A",
            "#8B5CFF",
            "#00CA69",
          ];
          let xAxisData = res.data.data.map((v) => v.date);
          let yAxisData2 = res.data.data.map((v) => v.num);
          const hexToRgba = (hex, opacity) => {
            let rgbaColor = "";
            let reg = /^#[\da-f]{6}$/i;
            if (reg.test(hex)) {
              rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
                "0x" + hex.slice(3, 5)
              )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
            }
            return rgbaColor;
          };

          let option = {
            backgroundColor: "rgba(0,0,0,0)",
            color: "#0078E6",
            legend: {
              right: 10,
              top: 10,
              show: false,
            },
            tooltip: {
              trigger: "axis",
              formatter: function (params) {
                let html = "";
                params.forEach((v) => {
                  html += `<div style="color: #666;font-size: 1.4rem;line-height: 2.4rem">
                <span style="display:inline-block;margin-right:.5rem;border-radius:1rem;width:1rem;height:1rem;background-color:${color[v.componentIndex]
                    };"></span>
                ${v.name}<br/>新增客户数
                
                <span style="color:${color[v.componentIndex]
                    };font-weight:700;font-size: 1.8rem">${v.value}</span>
                个`;
                });
                return html;
              },
              extraCssText:
                "background: #fff; border-radius: 0;box-shadow: 0 0 .3rem rgba(0, 0, 0, 0.2);color: #333;",
              axisPointer: {
                type: "shadow",
                shadowStyle: {
                  color: "#ffffff",
                  shadowColor: "rgba(225,225,225,1)",
                  shadowBlur: 5,
                },
              },
            },
            grid: {
              top: 100,
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                boundaryGap: false,
                axisLabel: {
                  formatter: "{value}",
                  textStyle: {
                    color: "#333",
                  },
                },
                axisLine: {
                  lineStyle: {
                    color: "#D9D9D9",
                  },
                },
                data: xAxisData,
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "客户数",
                axisLabel: {
                  textStyle: {
                    color: "#666",
                  },
                },
                nameTextStyle: {
                  color: "#666",
                  fontSize: 12,
                  lineHeight: 40,
                },
                splitLine: {
                  lineStyle: {
                    type: "dashed",
                    color: "#E9E9E9",
                  },
                },
                axisLine: {
                  show: false,
                },
                axisTick: {
                  show: false,
                },
              },
            ],
            series: [
              {
                name: "日期",
                type: "line",
                smooth: true,
                // showSymbol: false,
                symbolSize: 8,
                zlevel: 3,
                lineStyle: {
                  normal: {
                    color: "#0078E6",
                    shadowBlur: 3,
                    shadowColor: hexToRgba("#0078E6", 0.5),
                    shadowOffsetY: 8,
                  },
                },
                areaStyle: {
                  normal: {
                    color: new echarts.graphic.LinearGradient(
                      0,
                      0,
                      0,
                      1,
                      [
                        {
                          offset: 0,
                          color: hexToRgba("#0078E6", 0.3),
                        },
                        {
                          offset: 1,
                          color: hexToRgba("#0078E6", 0.1),
                        },
                      ],
                      false
                    ),
                    shadowColor: hexToRgba("#0078E6", 0.1),
                    shadowBlur: 10,
                  },
                },
                data: yAxisData2,
              },
            ],
          };
          myChart.setOption(option);

          //   myChart.setOption({
          //     title: {
          //       text: "新客户走势图",
          //       textStyle: {
          //         fontSize: "2rem",
          //       },
          //     },
          //     legend: {
          //       // icon: "circle",
          //       // top: "5%",
          //       // right: "5%",
          //       // itemWidth: 6,
          //       // itemGap: 20,
          //       // textStyle: {
          //       //   color: "#556677",
          //       // },
          //     },
          //     tooltip: {},
          //     xAxis: {
          //       type: "category",
          //       data: arr,
          //     },
          //     yAxis: {
          //       type: "value",
          //     },
          //     series: [
          //       {
          //         name: "新增客户数",
          //         data: aee,
          //         type: "line",
          //         lineStyle: {
          //           color: "#298EDB",
          //         },
          //         itemStyle: {
          //           color: "#298EDB",
          //           borderWidth: 4,
          //         },
          //       },
          //     ],
          //   });
          // })

          //   let myChart = this.$echarts.init(document.getElementById("myChart"));
          //   myChart.setOption({
          //     title: { text: "数据统计" },
          //     tooltip: {},
          //     xAxis: {
          //       data: arr,
          //     },
          //     yAxis: {},
          //     series: [
          //       {
          //         name: "数据统计",
          //         type: "bar",
          //         barWidth: 40,
          //         data: aee,
          //         itemStyle: { color: "#298EDB" },
          //       },
          //     ],
          //   });
        })
        .catch(function (err) { });
      // 基于准备好的dom，初始化echarts实例
    },
    getActiveCode() {
      this.drawLine();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getActiveCode();
    },
    add() {
      this.$router.push({
        name: "activeCodeADD",
        // query:{
        //     tableData: this.tableData
        // }
      });
    },
    //选择成员弹出组件
    openDrawer() {
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      this.originUser = person.name;
      this.originUserId = person.userid;
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
}

.body {
  /* width: 95%; */
  /* margin: 0 auto; */
  padding: 2rem;
}

nav {
  justify-content: flex-end;
}

.nav {
  width: 100%;
  height: 6rem;
  background-color: #ff9393;
  line-height: 6rem;
  padding-left: 3rem;
  border: .1rem solid #7d7d7d;
}

.nav a {
  color: blue;
}

.body-botm {
  background-color: #f8f8f8;
}

.botm-nav {
  height: 7rem;
  background-color: #dcdcdc;
  line-height: 7rem;
  padding-left: 3rem;
  color: #3088db;
}

.botm-nav span {
  padding-bottom: .4rem;
  border-bottom: .2rem solid #3088db;
}

.body-name {
  padding: 3rem;
}

.name-bottom {
  height: 5rem;
  line-height: 5rem;
}

::v-deep .el-table thead {
  color: #ffffff;
}

.nav-title {
  font-size: 1.8rem;
  font-weight: 500;
  color: #19273c;
}

.nav-r {
  display: flex;
}
</style>

